var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 2,
    x2: 11,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#417cef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.5,
    y1: 8,
    x2: 9.5,
    y2: 8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.5,
    y1: 10,
    x2: 8.5,
    y2: 10,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 9,
    x2: 12.5,
    y2: 9,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.47,3.42v.58h.53v-.58h-.53ZM1.29,4h9.18v-1.16H1.29v1.16ZM11,3.42v-1.3h-1.06v1.3h1.06ZM8.77.02L1.11,1.21l.15,1.14,7.66-1.19-.15-1.14ZM1.11,1.21c-.64.1-1.11.69-1.11,1.39h1.06c0-.12.08-.23.2-.24l-.15-1.14ZM11,2.12C11,.83,9.95-.16,8.77.02l.15,1.14c.53-.08,1.01.37,1.01.95h1.06ZM1.29,2.84c-.13,0-.23-.11-.23-.25H0c0,.77.58,1.4,1.29,1.4v-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,8h5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,10h4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1,3.71v9.18c0,1.17.92,2.12,2.06,2.12h6.88c1.14,0,2.06-.95,2.06-2.12v-3.53M1,3.71v-.71M1,3.71h8.94c1.14,0,2.06.95,2.06,2.12v.71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsGradient);
export default __webpack_public_path__ + "static/media/Documents Gradient.67ab245a43be706637d4195e823c9b88.svg";
export { ForwardRef as ReactComponent };